import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-esg-06.jpg";

import socialImg01 from "../../assets/img/social-img01.jpg";
import socialImg02 from "../../assets/img/social-img02.jpg";
import socialImg03 from "../../assets/img/social-img03.jpg";
import socialImg04 from "../../assets/img/social-img04.jpg";

function SocialContirb() {
	// 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
		
     {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>사회공헌</h2>
						<p>위피아는 지속가능한 경영을 위해 사회적 역할과 책임을 다하고 신뢰받는 기업이 되기 위해 노력합니다.</p>
					</div>
					<SubMenu />
			</section>

			{/* 사회공헌 */}
			<section className="social-contirb">
				<div className="container-auto sec-mt title-box">
					<h3 className="sub-title">사회공헌</h3>
					<p className="sub-text">위피아는 사회의 발전에 기여하는 핵심 주체로서, 사회적 책임을 다하는 기업시민으로서의 역할을 수행하며, 사회적 책임 실현을 통해 모두가 행복하고 더 나은 세상을 만들어가는 기업 문화를 조성합니다.</p>
				</div>

				<div className="bg-blue sec-py">
					<div className="container-auto sub-title-box">
						<h4 className="title">사회공헌 체계도</h4>
						<p className="text">위피아는 사회공헌에 이바지하는 기업이 되기 위해 최선을 다합니다.</p>
					</div>

					<div className="social-step">
							<ul className="list container-auto">
								<li>
									<div className="text-box">
										<p className="tit">비전</p>
										<p className="txt">모두가 행복한 세상을 만드는 기업</p>
									</div>
								</li>
								<li>
									<div className="text-box">
										<p className="tit">미션</p>
										<p className="txt">모두가 함께하는 지속가능한 사회를 만드는 기업</p>
									</div>
								</li>
								<li>
									<div className="text-box">
										<p className="tit">슬로건</p>
										<p className="txt">함께 만들어가는 지속가능한 세상</p>
									</div>
								</li>
							</ul>
					</div>
					<ul className="container-auto enviro-list social-list">
						<li>
							<p className="tit"><span>01</span> 추진전략</p>
							<p className="txt">지속가능한 사회공헌 체계구축</p>
						</li>
						<li>
							<p className="tit"><span>02</span> 추진전략</p>
							<p className="txt">사회적 약자 배려와 존중의 문화 확산</p>
						</li>
						<li>
							<p className="tit"><span>03</span> 추진전략</p>
							<p className="txt">지역공동체와 연대 협력 강화 및 체계 고도화</p>
						</li>
					</ul>
				</div>
			</section>

			{/* 사회공헌 활동 */}
			<section className="container-auto sec-my">
				<h3 className="sub-title">사회공헌</h3>
				<ul className="social-img-list">
					<li>
						<img src={socialImg01} />
						<p className="tit">지역 전통시장 활성화 참여</p>
					</li>
					<li>
						<img src={socialImg02} />
						<p className="tit">장애인기업 물품 구입</p>
					</li>
					<li>
						<img src={socialImg03} />
						<p className="tit">2023 환경정화 활동</p>
					</li>
					<li>
						<img src={socialImg04} />
						<p className="tit">2024 환경정화 활동</p>
					</li>
				</ul>
			</section>
		</main>
	<Footer />
    
    </>
        
    )
}

export default SocialContirb;